var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.iconComponent,{tag:"component",staticClass:"aha-svg",class:{ 'path-fill-current': !_vm.maintainColor },attrs:{"width":_vm.width || _vm.fallbackWidth,"height":_vm.height || _vm.fallbackWidth,"viewBox":_vm.viewBox},on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }